import React from 'react';
import { useTranslation } from 'react-i18next';
import { FolderOpen, X } from 'lucide-react';

const MailCreateFolderModal = ({
  createFolder,
  newFolderName,
  setNewFolderName,
  setShowCreateFolderModal
}) => {
  const { t } = useTranslation('admin');
  return (
    <>
        <div data-testid="mail-create-folder-modal" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm">
            <div className="p-6 border-b border-slate-200">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-bold text-slate-900 flex items-center">
                  <FolderOpen size={20} className="mr-2 text-purple-600" />
                  {t('mail.newFolder')}
                </h3>
                <button
                  data-testid="mail-create-folder-close"
                  onClick={() => {
                    setShowCreateFolderModal(false);
                    setNewFolderName('');
                  }}
                  className="p-2 hover:bg-slate-100 rounded-full transition-colors"
                >
                  <X size={20} className="text-slate-500" />
                </button>
              </div>
            </div>
            <div className="p-6">
              <input
                type="text"
                data-testid="mail-create-folder-input"
                value={newFolderName}
                onChange={(e) => setNewFolderName(e.target.value)}
                placeholder={t('mail.folderNamePlaceholder')}
                className="w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                autoFocus
                onKeyDown={(e) => {
                  if (e.key === 'Enter') createFolder();
                }}
              />
            </div>
            <div className="p-6 pt-0 flex justify-end space-x-3">
              <button
                onClick={() => {
                  setShowCreateFolderModal(false);
                  setNewFolderName('');
                }}
                className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-xl transition-colors"
              >
                {t('mail.cancelBtn')}
              </button>
              <button
                data-testid="mail-create-folder-submit"
                onClick={createFolder}
                disabled={!newFolderName.trim()}
                className="px-4 py-2 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {t('mail.create')}
              </button>
            </div>
          </div>
        </div>
    </>
  );
};

export default MailCreateFolderModal;
